import React from "react";
import PropTypes from "prop-types";
import styles from "./BackButton.scss";
import { BackButton } from "./BackButton";



export function BackButtonLabel({ label, ...rest }) {
  return (
    <div className={styles.backButtonContainer}>
      <BackButton {...rest}></BackButton>
      {label && <label>{label}</label>}
    </div>
  );
}

BackButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

